import React, { useState } from 'react';
import { usePayrollAuth } from './PayrollAuth';
import './PayrollLogin.css';

export default function PayrollLogin() {
  const { login } = usePayrollAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/payroll/auth/payroll-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const err = await res.json();
        setError(err.detail || 'Ошибка входа');
        return;
      }
      const data = await res.json();
      login(data.token, data.user);
    } catch {
      setError('Ошибка соединения');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pl-bg">
      <div className="pl-card">
        <div className="pl-logo">
          <div className="pl-logo-icon">₮</div>
          <div className="pl-logo-text">THOTH AI</div>
          <div className="pl-logo-sub">Ведомости</div>
        </div>
        <form onSubmit={handleSubmit} className="pl-form">
          <div className="pl-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              autoFocus
            />
          </div>
          <div className="pl-field">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error && <div className="pl-error">{error}</div>}
          <button type="submit" className="pl-btn" disabled={loading}>
            {loading ? 'Входим...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}
